import { setLoading, addAlert } from "src/modules/notification/redux";
import { getApprovalAvailableAccessRight, putApproval } from "../action";

// The api rejects with the SERVER'S message, so a rejected approval carries the real reason
// in action.payload. Same helper (and same rule) as bundles.middleware.
const failureMessage = (action, fallback) => action.payload || fallback;

const getApprovalAvailableAccessRightMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    const { payload, type } = action;

    switch (type) {
      case getApprovalAvailableAccessRight.pending.type:
        dispatch(
          setLoading({
            id: getApprovalAvailableAccessRight.typePrefix,
            state: true,
          })
        );
        break;
      case getApprovalAvailableAccessRight.fulfilled.type:
        dispatch(
          setLoading({
            id: getApprovalAvailableAccessRight.typePrefix,
            state: false,
          })
        );
        break;
      case getApprovalAvailableAccessRight.rejected.type:
        dispatch(
          setLoading({
            id: getApprovalAvailableAccessRight.typePrefix,
            state: false,
          })
        );
        dispatch(
          addAlert({
            severity: "error",
            message: payload.code,
          })
        );
        break;
      default:
        break;
    }
  };

// Approving is the wizard's write. On approve it carries the bundle the Access Rights step
// resolved, which for a brand-new module set was CREATED first — so the bundles middleware
// has already put a green "Bundle Created successfully" on this snackbar. The rejected case
// below is what stops that green toast from being the only thing the admin sees when the
// approval itself was refused and the company was never approved or moved.
const putApprovalMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);

    const { type } = action;

    switch (type) {
      case putApproval.pending.type:
        dispatch(setLoading({ id: putApproval.typePrefix, state: true }));
        break;
      case putApproval.fulfilled.type:
        dispatch(setLoading({ id: putApproval.typePrefix, state: false }));
        break;
      case putApproval.rejected.type:
        dispatch(setLoading({ id: putApproval.typePrefix, state: false }));
        dispatch(
          addAlert({
            severity: "error",
            message: failureMessage(
              action,
              "Failed to process company approval"
            ),
          })
        );
        break;
      default:
        break;
    }
  };

export default [getApprovalAvailableAccessRightMiddleware, putApprovalMiddleware];
